/** Order Protection connect step — derived by the backend from OP plus the persisted store id. */
export enum OrderProtectionConnectionStep {
  NOT_CONNECTED = 'NOT_CONNECTED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  APPROVED = 'APPROVED',
  CONNECTED = 'CONNECTED',
}

export interface OrderProtectionConnectionStatus {
  step: OrderProtectionConnectionStep;
  storeId?: string;
  collaborationCode?: string;
}

export const ORDER_PROTECTION_BASE = 'integrations/order-protection';
export const OP_DASHBOARD_URL = 'https://app.orderprotection.com';
